import { createCachedSelector } from 're-reselect';

import getBuildData from '@/state/selectors/saved-builds/get-build-data';
import { IStore } from '@/state/slices/typings';
import { typedObjectKeys } from '@multitenancy-spa/utils';

const getBuildDataTotal = createCachedSelector(
	[
		getBuildData,
		(
			_: IStore,
			activeBrand?: 'range-rover' | 'defender' | 'discovery' | undefined,
		) => activeBrand,
	],
	(buildsData, activeBrand) => {
		const keys = typedObjectKeys(buildsData);
		if (keys.length === 0) return 0;

		return keys.reduce((acc, buildsBrand) => {
			if (
				activeBrand === undefined ||
				(activeBrand === 'range-rover' &&
					buildsBrand === 'range_rover') ||
				(activeBrand !== 'range-rover' && buildsBrand !== 'range_rover')
			) {
				acc += buildsData[buildsBrand].configurations.length;
			}
			return acc;
		}, 0);
	},
)((_: IStore, activeBrand) => activeBrand || '');

export default getBuildDataTotal;
